const GOOGLE_TRANSLATE_URL = 'https://translate.googleapis.com/translate_a/single';
const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'CODE', 'PRE', 'NOSCRIPT']);
const CONCURRENCY = 6;

async function translateText(text, targetLang) {
  const params = new URLSearchParams({
    client: 'gtx',
    sl: 'auto',
    tl: targetLang,
    dt: 't',
    q: text,
  });
  const res = await fetch(`${GOOGLE_TRANSLATE_URL}?${params.toString()}`);
  if (!res.ok) throw new Error(`Translate request failed: ${res.status}`);
  const data = await res.json();
  return (data?.[0] || []).map((segment) => segment?.[0] || '').join('');
}

async function runWithConcurrency(items, worker, concurrency) {
  const results = new Array(items.length);
  let cursor = 0;
  const runners = Array.from(
    { length: Math.min(concurrency, items.length) },
    async () => {
      while (cursor < items.length) {
        const i = cursor;
        cursor += 1;
        // eslint-disable-next-line no-await-in-loop
        results[i] = await worker(items[i], i);
      }
    },
  );
  await Promise.all(runners);
  return results;
}

function shouldSkipNode(node, root) {
  let parent = node.parentNode;
  while (parent && parent !== root) {
    if (SKIP_TAGS.has(parent.nodeName)) return true;
    parent = parent.parentNode;
  }
  return false;
}

export default async function translateHtml(html, targetLang = 'hi') {
  if (typeof window === 'undefined' || !html) return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div id="__t_root">${html}</div>`, 'text/html');
  const root = doc.getElementById('__t_root');

  const textNodes = [];
  const walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  let node = walker.nextNode();
  while (node) {
    if (node.nodeValue && node.nodeValue.trim() && !shouldSkipNode(node, root)) {
      textNodes.push(node);
    }
    node = walker.nextNode();
  }

  const translated = await runWithConcurrency(
    textNodes.map((n) => n.nodeValue),
    (text) => translateText(text, targetLang).catch(() => text),
    CONCURRENCY,
  );

  textNodes.forEach((n, i) => {
    const original = n.nodeValue;
    const leadingWs = original.match(/^\s*/)?.[0] || '';
    const trailingWs = original.match(/\s*$/)?.[0] || '';
    // eslint-disable-next-line no-param-reassign
    n.nodeValue = `${leadingWs}${translated[i].trim()}${trailingWs}`;
  });

  return root.innerHTML;
}
